// Listed up front; the view itself (./progression-player.tsx) loads on demand.
export const id = 'progression-player';
export const title = 'Progression player';
export const order = 50;
